<template>
  <div class="header-info">
    <div class="clubs-logos">
      <v-img :src="partido.localLogo.logo" height="70%" width="70%" contain class="logo-local"></v-img>
      <span class="goles-local">{{partido.localGoals}}<span v-if="partido.localPenaltyGoals" class="goles-penales">{{`(${partido.localPenaltyGoals})`}}</span>
      </span>
      <span class="guion">-</span>
      <span class="goles-visitante">{{ partido.visitorGoals }}<span v-if="partido.visitorPenaltyGoals" class="goles-penales">{{`(${partido.visitorPenaltyGoals})`}}</span>
      </span>
      <v-img :src="partido.visitorLogo.logo" height="70%" width="70%" contain class="logo-visitante"></v-img>
    </div>
    <div class="torneo">
      <span>Torneo: <b>{{ this.partido.tournamentName }}</b></span>
      <span><b>{{ this.partido.fechaName }}</b></span>
    </div>
    <div class="estadio">
      <span>
        Día y horario: <b>{{ this.partido.dateRealization }}</b>
        <v-icon v-if="this.$store.state.permissions.canEditDateTimeAndStadiumFichaPartido" @click="handlerPencilClick('datetime')" class="edit-pencil" size="large" color="info">mdi-pencil</v-icon>
      </span>
      <span>
        Estadio: <b>{{ this.partido.stadium }}</b>
        <v-icon v-if="this.$store.state.permissions.canEditDateTimeAndStadiumFichaPartido" @click="handlerPencilClick('stadium')" class="edit-pencil" size="large" color="info">mdi-pencil
        </v-icon>
      </span>
    </div>
    <div class="contactos-operativos">
      <div class="contactos-local">
        <h3>{{ this.partido.clubLocal }}</h3>
        <span>Titular: <b>{{ this.partido.localContactosOperativos.titular }}</b></span>
        <span>Suplente: <b>{{ this.partido.localContactosOperativos.suplente }}</b></span>
      </div>
      <span class="contactos-title">Contactos operativos</span>
      <div class="contactos-visitante">
        <h3>{{ this.partido.clubVisitor }}</h3>
        <span>Titular: <b>{{ this.partido.visitorContactosOperativos.titular }}</b></span>
        <span>Suplente: <b>{{ this.partido.visitorContactosOperativos.suplente }}</b></span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  components: {

  },
  props: {
    partido: null
  },
  methods: {
    handlerPencilClick (editType) {
      this.$emit('activateEditPopUp', {
        editMode: true,
        editType: editType,
        editTitle: editType === 'stadium' ? 'Editar estadio' : 'Editar día y horario'
      })
    }
  }
}
</script>

<style scoped>
.header-info {
  width: 100%;
  height: 250px;
  display: grid;
  grid-template-columns: 1.5fr 1fr 2fr;
  grid-template-rows: 1fr 1fr 0.5fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  box-shadow: 0px 7px 10px 0px rgba(0, 0, 0, 0.43);
  -webkit-box-shadow: 0px 7px 10px 0px rgba(0, 0, 0, 0.43);
  -moz-box-shadow: 0px 7px 10px 0px rgba(0, 0, 0, 0.43);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.clubs-logos {
  display: grid;
  grid-template-columns: 30% 10% 10% 10% 30%;
  gap: 2.5%;
  grid-area: 1 / 1 / 4 / 2;
  border-right: 2px solid #676767;
  align-items: center;
}

.goles-local,
.goles-visitante,
.guion {
  font-size: 3em;
}

.guion {
  text-align: center;
}

.goles-local {
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.goles-visitante {
  display: flex;
  text-align: left;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.logo-local {
  justify-self: end;
}

.logo-left {
  justify-self: start
}

.torneo {
  grid-area: 1 / 2 / 2 / 3;
  border-right: 2px solid #676767;
  border-bottom: 2px solid #676767;
  display: grid;
  text-align: start;
  align-items: center;
  padding-left: 30px;
  place-content: flex-start;
  align-content: center;
  row-gap: 10px;
}

.torneo>span,
.estadio>span {
  font-size: 1.2em;
}

.estadio {
  grid-area: 1 / 3 / 2 / 4;
  border-bottom: 2px solid #676767;
  display: grid;
  text-align: start;
  align-items: center;
  padding-left: 30px;
  place-content: flex-start;
  align-content: center;
  row-gap: 10px;
}

.contactos-operativos {
  grid-area: 2 / 2 / 4 / 4;
  display: flex;
  flex-direction: row;
  justify-content: center;
  justify-content: space-evenly;
}

.contactos-local,
.contactos-visitante {
  display: flex;
  align-self: center;
  flex-direction: column;
}

.contactos-local>span,
.contactos-visitante>span {
  font-size: 1.2em;
}

.contactos-local>h3,
.contactos-visitante>h3 {
  font-size: 1.4em;
  text-align: center;
  color: #293968;
}

.contactos-title {
  font-size: 1.4em;
  padding-top: 10px;
}

.edit-pencil {
  padding-left: 5px;
  padding-bottom: 3px;
}

.goles-penales{
  font-size: 25px;
}

</style>
